import React from 'react';
import services from '../../services';

const UserModerationSummary = ({selectedUser}) => {

    const { data: userSummary } = services?.moderation?.useUserModerationSummary(
        selectedUser?.id
    ) || { data: null };    
    
    const getActionTypeBadge = (actionType) => {
        if (!actionType) return '-';
        
        const badgeClasses = {
            'USER_BANNED': 'bg-red-100 text-red-700',
            'USER_UNBANNED': 'bg-green-100 text-green-700',
            'POST_REMOVED': 'bg-yellow-100 text-yellow-700',
            'REPORT_DISMISSED': 'bg-blue-100 text-blue-700'
        };
        
        const colorClass = badgeClasses[actionType] || 'bg-gray-100 text-gray-700';
        const displayText = actionType.replace(/_/g, ' ');
        
        return (
            <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${colorClass}`}>
                {displayText}
            </span>
        );
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
                <h4 className="text-lg font-semibold text-gray-800">
                    Moderation Summary: {userSummary?.userName ||""}
                </h4>
            </div>
            
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-200">
                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                User ID
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Name
                            </th>
                            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Report Count
                            </th>
                            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Active Reports
                            </th>
                            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Ban Count
                            </th>
                            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Unban Count
                            </th>
                            <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Post Deletions
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Last Action
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                Last Moderated
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {userSummary ? (
                            <tr className="hover:bg-gray-50 transition-colors duration-150">
                                <td className="px-4 py-4 text-sm text-gray-900 font-medium">
                                    {userSummary.userId || '-'}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-900">
                                    {userSummary.userName || '-'}
                                </td>
                                <td className="px-4 py-4 text-sm text-center text-gray-900 font-medium">
                                    {userSummary.reportCount ?? 0}
                                </td>
                                <td className="px-4 py-4 text-sm text-center text-gray-900 font-medium">
                                    {userSummary.activeReports ?? 0}
                                </td>
                                <td className="px-4 py-4 text-sm text-center text-gray-900 font-medium">
                                    {userSummary.banCount ?? 0}
                                </td>
                                <td className="px-4 py-4 text-sm text-center text-gray-900 font-medium">
                                    {userSummary.unbanCount ?? 0}
                                </td>
                                <td className="px-4 py-4 text-sm text-center text-gray-900 font-medium">
                                    {userSummary.postDeletions ?? 0}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-900">
                                    {getActionTypeBadge(userSummary.lastActionType)}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-600">
                                    {userSummary.lastModeratedAt 
                                        ? new Date(userSummary.lastModeratedAt).toLocaleDateString('en-GB', { 
                                            day: '2-digit', 
                                            month: 'short', 
                                            year: 'numeric' 
                                        })
                                        : '-'
                                    }
                                </td>
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan="9" className="px-4 py-8 text-sm text-center text-gray-500">
                                    Loading user data...
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default UserModerationSummary;